/**
 * @Create idler.zhu(zqc.sunny@aliyun.com)
 * @CreateDate  2017/12/25
 */
class Storage {
  constructor() {
    this.prefix = 'MEIZU_STORE_MCYCLE_STORAGE_';
    this.storage = window.sessionStorage || {};
  }
  setItem (key, value) {
    this.storage[`${this.prefix}${key}`] = JSON.stringify(value);
  }
  getItem (key) {
    try {
      const value = this.storage[`${this.prefix}${key}`];
      if (value) {
        return JSON.parse(value);
      }
      return undefined;
    } catch (e) {
      return undefined;
    }
  }
  clearItem (key) {
    this.storage.removeItem(`${this.prefix}${key}`);
  }
}

export default new Storage();



// WEBPACK FOOTER //
// ./src/utils/sessionStorage.js